import "./FormattedText.scss"

import { FC, PropsWithChildren } from "react"

interface IFormattedTextProps {
    text?: string
}

const FormattedText: FC<PropsWithChildren<IFormattedTextProps>> = ({
    text,
}) => {
    if (!text) return null

    return (
        <div
            className="formatted-text ck-content"
            dangerouslySetInnerHTML={{ __html: text }}
        />
    )
}

export default FormattedText
